import { useFadeIn } from '@/hooks/useFadeIn';

export default function IconBeforeAfter() {
  const heading = useFadeIn({ direction: 'up' });
  const sub = useFadeIn({ direction: 'up', delay: 100 });
  const images = useFadeIn({ direction: 'up', delay: 200 });
  const badges = useFadeIn({ direction: 'up', delay: 300 });

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div ref={heading.ref} style={heading.style} className="text-center mb-10 md:mb-14">
          <h2 className="font-serif text-gray-900 text-2xl md:text-4xl leading-relaxed">
            写真が語る、ICONの実力
          </h2>
          <p className="font-light text-gray-500 text-sm md:text-base mt-4 leading-relaxed max-w-xl mx-auto">
            たった1回の治療で、ここまで改善することがあります。<br className="hidden md:block" />
            削らない。痛みが少ない。自然な仕上がり。
          </p>
        </div>

        <div ref={sub.ref} style={sub.style} className="text-center mb-8 md:mb-10">
          <p className="font-normal text-gray-900 text-base md:text-lg leading-relaxed">
            こんな白い点でお悩みではありませんか?
          </p>
          <p className="font-light text-gray-500 text-sm md:text-base mt-2 leading-relaxed">
            長年気になっていた白い点も、自然な見た目へ改善できる可能性があります。
          </p>
        </div>

        <div ref={images.ref} style={images.style}>
          <div className="flex flex-col md:flex-row gap-4 md:gap-0">
            {/* Before */}
            <div className="w-full md:w-1/2 relative">
              <div className="relative rounded-lg overflow-hidden border-2 border-red-50 md:rounded-r-none">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    alt="ホワイトスポット症例(治療前)"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/b119c5cc47f4450f9ed4c4db51afaf39.jpeg"
                  />
                </div>
                <div className="absolute top-3 left-3 bg-red-500/90 backdrop-blur-sm text-white font-medium text-xs px-3 py-1.5 rounded-full whitespace-nowrap">
                  BEFORE
                </div>
              </div>
            </div>

            {/* 矢印 デスクトップ */}
            <div className="hidden md:flex items-center justify-center w-12 -mx-2 z-10">
              <div
                className="w-10 h-10 rounded-full text-white flex items-center justify-center"
                style={{ backgroundColor: '#3E5F8F' }}
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </div>
            </div>
            {/* 矢印 モバイル */}
            <div className="flex md:hidden items-center justify-center py-1">
              <div
                className="w-10 h-10 rounded-full text-white flex items-center justify-center"
                style={{ backgroundColor: '#3E5F8F' }}
              >
                <i className="ri-arrow-down-line text-lg"></i>
              </div>
            </div>

            {/* After */}
            <div className="w-full md:w-1/2 relative">
              <div className="relative rounded-lg overflow-hidden border-2 border-green-50 md:rounded-l-none">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    alt="ホワイトスポット症例(治療後)"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/63a480ed3842d5cd03e9373db0882361.jpeg"
                  />
                </div>
                <div className="absolute top-3 left-3 bg-green-600/90 backdrop-blur-sm text-white font-medium text-xs px-3 py-1.5 rounded-full whitespace-nowrap">
                  AFTER
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* バッジ */}
        <div ref={badges.ref} style={badges.style} className="mt-10 md:mt-14">
          <div className="flex flex-wrap justify-center gap-4 md:gap-6">
            {[
              { icon: 'ri-check-line', label: '削らない' },
              { icon: 'ri-check-line', label: '麻酔不要' },
              { icon: 'ri-time-line', label: '約30〜60分' },
              { icon: 'ri-calendar-check-line', label: '1回の通院で完了' },
            ].map((item) => (
              <div
                key={item.label}
                className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-full px-4 py-2.5"
              >
                <span
                  className="w-5 h-5 flex items-center justify-center rounded-full"
                  style={{ backgroundColor: '#d1fae5', color: '#16a34a' }}
                >
                  <i className={`${item.icon} text-sm`}></i>
                </span>
                <span className="font-medium text-gray-900 text-sm whitespace-nowrap">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8 md:mt-10">
          <p className="font-light text-gray-400 text-xs md:text-sm leading-relaxed">
            ※白斑の深さや原因によって改善度は異なります。<br className="hidden md:block" />
            カウンセリングで個別にご説明します。
          </p>
        </div>
      </div>
    </section>
  );
}